/* Studiz motion layer: small, dependency-free, and safe to fail (every feature is isolated). */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function safe(fn) {
    try {
      fn();
    } catch (e) {
      /* a motion feature must never break the store */
    }
  }

  /* 1. Section headings: draw the accent bar when scrolled into view */
  function initHeadings() {
    var els = document.querySelectorAll('.title-wrapper h2.title:not(.studiz-heading)');
    if (!els.length) return;
    els.forEach(function (el) {
      el.classList.add('studiz-heading');
      var align = getComputedStyle(el).textAlign;
      if (align === 'left' || align === 'start') el.classList.add('studiz-heading--left');
    });
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('is-inview');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-inview');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px' }
    );
    els.forEach(function (el) {
      io.observe(el);
    });
  }

  /* 2. Cart count bump when an item is added */
  function initCartBump() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(function () {
        document.querySelectorAll('#cart-icon-bubble .cart-count-bubble, .m-nav__badge:not([hidden])').forEach(function (bubble) {
          bubble.classList.remove('studiz-bump');
          void bubble.offsetWidth; /* restart the animation */
          bubble.classList.add('studiz-bump');
        });
      }, 350);
    });
  }

  /* 3. Prefetch on hover/touch for browsers without Speculation Rules support
        (theme.liquid already covers Chrome/Edge). Cart/checkout/account are never prefetched. */
  function initPrefetch() {
    if (window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) return;
    var conn = navigator.connection;
    if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ''))) return;

    var done = {};
    var blocked = /^\/(cart|checkout|account|customer|orders|search)|logout/;
    var timer;

    function consider(target) {
      var a = target && target.closest ? target.closest('a[href]') : null;
      if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
      var url;
      try {
        url = new URL(a.href, location.href);
      } catch (e) {
        return;
      }
      if (url.origin !== location.origin || blocked.test(url.pathname) || done[url.href]) return;
      if (url.pathname === location.pathname && url.search === location.search) return;
      done[url.href] = true;
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = url.href;
      document.head.appendChild(link);
    }

    document.addEventListener(
      'touchstart',
      function (e) {
        consider(e.target);
      },
      { passive: true }
    );
    document.addEventListener(
      'mouseover',
      function (e) {
        clearTimeout(timer);
        var t = e.target;
        timer = setTimeout(function () {
          consider(t);
        }, 65);
      },
      { passive: true }
    );
  }

  function init() {
    safe(initHeadings);
    safe(initCartBump);
    safe(initPrefetch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  /* Theme editor: re-run heading setup when a section is re-rendered */
  document.addEventListener('shopify:section:load', function () {
    safe(initHeadings);
  });
})();
